<template>
    <layout v-bind:user="user" v-bind:brands="brands" v-bind:company="company" title="アプローチDM新規作成" @selectList="displaySelectedBrand($event)">
        <main class="ly_main">
            <div class="wrap">
                <div class="inner">
                    <!--Heading-->
                    <h1 class="heading_page-title flex _y-center">
                        <div class="main"><span v-if="page_type == 0">アプローチDM 新規作成</span><span v-if="page_type == 1">アプローチDM 編集</span></div>
                        <div v-if="page_type == 1" class="controller flex _right _y-center">
                            <div>
                                <Link class="btn_link md_icon-text _white" v-on:click="dmDeletem"><div class="inner">
                                    <span>
                                        削除
                                        <div class="icon">
                                            <SvgIconDelete />
                                        </div>
                                    </span>
                                </div></Link>
                            </div><!--/.add-->
                        </div><!--/.controller-->
                    </h1><!--/.heading_page-title-->

                    <section>

                        <div class="dm_component">

                            <div class="md_common-bl">
                                <div class="inner">

                                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                                        Register
                                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                                    <div class="register-wrap news_component">
                                        <form v-on:submit.prevent="dmPost">
                                            <!-- PostTitle -->
                                            <div class="post-title">
                                                <!-- Title -->
                                                <div class="item form_text _big">
                                                    <div class="input-row">
                                                        <input type="text" maxlength="250" id="dm-title" v-model="title" required>
                                                    </div>
                                                    <label for="dm-title"><span>タイトル</span></label>
                                                </div>
                                            </div>
                                            <!-- SelectItem -->
                                            <div class="post-title" v-if="pageType == 1">
                                                <div class="item form_select">
                                                    <div class="text-row">送信先</div>
                                                    <div class="input-row">
                                                        <select v-model="send_type" required>
                                                            <option v-for="brand_send_type in pulldown_brand_send_type"
                                                                v-bind:value="brand_send_type.id "
                                                                v-bind:key="brand_send_type.id">
                                                                {{ brand_send_type.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- SelectItem -->
                                            <div class="post-title" v-if="pageType == 2">
                                                <div class="item form_select">
                                                    <div class="text-row">送信先</div>
                                                    <div class="input-row">
                                                        <select v-model="send_type" required>
                                                            <option v-for="showroom_send_type in pulldown_showroom_send_type"
                                                                v-bind:value="showroom_send_type.id"
                                                                v-bind:key="showroom_send_type.id">
                                                                {{ showroom_send_type.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- PostBody -->
                                            <div class="post-body">
                                                <div class="item form_textarea">
                                                    <textarea maxlength="250" v-model="text" placeholder="" required></textarea>
                                                </div>
                                            </div>

                                            <!--btn-link-wrap-->
                                            <div class="btn_link-wrap">

                                                <!--LinkBtn - キャンセル -->
                                                <button v-on:click="draftDmPost" class="btn_link _cancel md_icon-text">
                                                    <div class="inner">
                                                        <span><div class="icon"><SvgIconEdit /></div>下書き保存</span>
                                                    </div>
                                                </button>

                                                <!--LinkBtn - 決定アイコン -->
                                                <button class="btn_link md_icon-text _white">
                                                    <div class="inner">
                                                        <span><div class="icon"><SvgIconCheck /></div>送信</span>
                                                    </div>
                                                </button>

                                            </div><!--/.btn-link-wrap-->
                                        </form>

                                    </div><!-- /.register-wrap -->


                                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                                        Preview
                                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                                    <div class="preview-wrap talk_component">

                                        <h3><span>プレビュー</span></h3>

                                        <div class="wrap">
                                            <div class="talk-inner">

                                                <!-- Bubble -->
                                                <div class="bubble-item">
                                                    <div class="avatar-wrap">
                                                        <img src="/img/smp/end-user-shop1.jpg" alt="" class="avatar">
                                                    </div>
                                                    <div class="bubble-wrap">
                                                        <div class="bubble-body">
                                                            <p><span>{{text}}</span></p>
                                                        </div>
                                                        <time>20xx/xx/xx 00:00</time>
                                                    </div>
                                                </div>

                                            </div><!-- /TalkInner -->
                                        </div><!-- /Wrap -->

                                    </div><!-- /.Preview-wrap -->
                                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                                        /Preview
                                    :::::::::::::::::::::::::::::::::::::::::::::::::-->

                                </div><!-- /.inner -->
                            </div><!-- /.md_common-bl -->
                        </div><!-- /.dm_component -->

                    </section>

                </div><!--/.ly_main .inner-->
            </div><!--/.ly_main .wrap-->
            <AlertModal 
                v-if="showAlertModal" 
                @close="closeAlertModal" 
                :title="alert_modal_title" 
                :message="alert_modal_message"
                :mode="alert_modal_mode" 
            />
            <ConfirmModalWithPromise ref="confirmModal" />
            <div class="heading_page-title-en"><span>{{backName}}</span></div>
        </main>
    </layout>
</template>

<script>

    import AdminLayout from '@/Layouts/AdminLayout'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/Admin/ComponentList/ConfirmModalWithPromise'

    //Svg
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'

    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            //Svg
            SvgIconDelete,
            SvgIconCancel,
            SvgIconCheck,
            SvgIconEdit,
        },
        data() {
            return {
                dm_id: 0, //0の場合は新規追加
                status: 0,
                title: '',
                text: '',
                list_index: 0,
                brand_id: 0,
                page_type: 0,
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
                send_type: 0,
                pulldown_brand_send_type: [
                    { id: 0, name: '全体' },
                    { id: 1, name: 'ショップ全体' },
                    { id: 2, name: 'ショールーム全体' },
                ],
                pulldown_showroom_send_type: [
                    { id: 0, name: '全体' },
                    { id: 1, name: 'ショップ全体' },
                    { id: 2, name: 'ブランド全体' },
                ],
                plan_validation: false,
            }
        },
        props: {
            user: Object,
            company: Object,
            brands: Object,
            listIndex: Object,
            brand_dm: Object,
        },
        created() {
            if (this.brand_dm) {
                this.dm_id = this.brand_dm.id;
                this.title = this.brand_dm.title;
                this.text = this.brand_dm.text;
                this.send_type = this.brand_dm.type;
                this.page_type = 1;
            }
            this.list_index = this.listIndex;
            this.$store.state.const.index = this.listIndex;
            var brand = this.brands[this.list_index];
            this.brand_id = brand.id;
        },
        methods: {
            displaySelectedBrand(index) {
                var select_brand = this.brands[index];

                if (select_brand.plan == 1 && (select_brand.subscription_status == 'active' || select_brand.subscription_status == 'onGracePeriod')) {
                    this.list_index = index;
                    const form = reactive({
                        listIndex: this.list_index,
                    })
                    if (this.pageType == 1) {
                        Inertia.get('/admin/brand/dm', form)
                    } else if (this.pageType == 2) {
                        Inertia.get('/admin/showroom/dm', form)
                    }
                } else {
                    this.plan_validation = true;
                    this.openAlertModal('error', 'DMはBASICプランのみのご利用になります', 'DMはBASICプランのみのご利用になります。');
                }
            },
            draftDmPost() {
                if (this.title && this.text) {
                    this.status = 1;
                }
            },
            async dmPost() {
                const form = reactive({
                    id: this.dm_id,
                    status: this.status,
                    title: this.title,
                    text: this.text,
                    send_type: this.send_type,
                    brand_id: this.brand_id,
                    listIndex: this.list_index,
                })
                if (this.pageType == 1) {
                    if (this.send_type == 0) {
                        var send_type_name = 'ショップとショールーム';
                    } else if (this.send_type == 1) {
                        var send_type_name = 'ショップ';
                    } else if (this.send_type == 2) {
                        var send_type_name = 'ショールーム';
                    }
                } else if (this.pageType == 2) {
                    if (this.send_type == 0) {
                        var send_type_name = 'ショップとブランド';
                    } else if (this.send_type == 1) {
                        var send_type_name = 'ショップ';
                    } else if (this.send_type == 2) {
                        var send_type_name = 'ブランド';
                    }
                }
                let dmConfirm;
                if (this.status !== 1) {
                    dmConfirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '送信しますか？',
                        message: 'このDMはマイセレクトルームに追加している' + send_type_name + '全てに送信されます。送信しますか？',
                        mode: "confirm",
                        name: "dmRegisterConfirm"
                    })
                }
                if (dmConfirm || this.status == 1) {
                    if (this.pageType == 1) {
                        var url = '/admin/brand/dm/register';
                    } else if (this.pageType == 2) {
                        var url = '/admin/showroom/dm/register';
                    }
                    Inertia.post(url, form, {
                        // onBefore: () => {
                        //     if (this.status !== 1) {
                        //         confirm('このDMはマイセレクトルームに追加しているショップ全てに送信されます。送信しますか？')
                        //     }
                        // },
                        onError: (errors) => {
                            if (errors.text) {
                                this.openAlertModal('error', 'エラー', errors.text);
                            }
                        },
                        onSuccess: (page) => {
                        },
                    })
                }
            },
            async dmDeletem() {
                const form = {
                    id: this.dm_id,
                    listIndex: this.list_index,
                }
                const dmConfirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '削除してもよろしいですか',
                    message: 'このDMを削除してもよろしいですか？',
                    mode: "delete",
                    name: "dmRegisterConfirm"
                })
                if (dmConfirm) {
                    if (this.pageType == 1) {
                        var url = '/admin/brand/dm/delete';
                    } else if (this.pageType == 2) {
                        var url = '/admin/showroom/dm/delete';
                    }
                    Inertia.post(url, form, {
                        // onBefore: () => {
                        //     confirm('このDMを削除してもよろしいですか？')
                        // },
                        onError: (errors) => {
                            if (errors) {
                                this.openAlertModal('error', 'エラー', '入力欄に正しく入力してください');
                            }
                        },
                        onSuccess: (page) => {
                        },
                    })
                }
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';

                if (this.plan_validation){
                    if (this.pageType == 1) {
                        Inertia.get(route('admin.brand.dashboard'));
                    } else if (this.pageType == 2) {
                        Inertia.get(route('admin.showroom.dashboard'));
                    }
                }
            }
        },
        computed: {
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
            pageType() {
                if (location.pathname == '/admin/brand/dm/register') {
                    return 1;
                } else if (location.pathname == '/admin/showroom/dm/register') {
                    return 2;
                }
            },
        },
    }
</script>

<style>
p {
    white-space: pre-wrap;
}
</style>